import { render, staticRenderFns } from "./Modeler.vue?vue&type=template&id=6819f610&"
import script from "./Modeler.vue?vue&type=script&lang=js&"
export * from "./Modeler.vue?vue&type=script&lang=js&"
import style0 from "./modeler.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports